var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirmation',{attrs:{"success":true,"success-title":"confirmation.kyc-documents-title"}})
}
var staticRenderFns = []

export { render, staticRenderFns }